// extracted by mini-css-extract-plugin
export default {"container":"AssetItemDetail_container__g3tEy"};